import { AssesmentIcon, CarePlanIcon, CareTeamIcon, DashboardIcon, HealthIcon, HelpIcon, LabTestIcon, MedicalRecordIcon, MedicineIcon, MyAppointmentIcon, PhoneIcon, RPMAlertIcon, SavedDocumentIcon } from "../../utils/functions/Icons";

const SidebarData: SidebarDataType[] = [
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: DashboardIcon
    },
    {
        title: 'Talk to Doctor',
        path: '/TalkToDoctor',
        icon: PhoneIcon
    },
    {
        title: 'Assessments',
        path: '/Assessments',
        icon: AssesmentIcon
    },
    {
        title: 'Book Lab tests',
        path: '/LabTests',
        icon: LabTestIcon
    },
    {
        title: 'Care team',
        path: '/CareTeam',
        icon: CareTeamIcon
    },
    {
        title: 'Care plan',
        path: '/CarePlan',
        icon: CarePlanIcon
    },
    {
        title: 'Vital Monitoring',
        path: '/vital-monitoring',
        icon: RPMAlertIcon
    },
    {
        title: 'Behavioural Health',
        path: '/BehaviouralHealth',
        icon: HealthIcon
    },
    {
        title: 'Medical record',
        path: '/MedicalRecord',
        icon: MedicalRecordIcon
    },
    {
        title: 'My medicine',
        path: '/MyMedicine',
        icon: MedicineIcon
    },
    {
        title: 'My appointments',
        path: '/MyAppointments',
        icon: MyAppointmentIcon
    },
    {
        title: 'Saved Documents',
        path: '/SavedDocuments',
        icon: SavedDocumentIcon
    },
    {
        title: 'Help',
        path: '/Help',
        icon: HelpIcon
    },
];

export default SidebarData;